// extracted by mini-css-extract-plugin
export default {"infoLink":"InfoLinks_infoLink__lrxFL","lastInfoBlock":"InfoLinks_lastInfoBlock__+PRHx"};